import type { ColorValue } from "../color-value";

const toHslaString = (color: {
    hue: ColorValue["hue"];
    saturation: ColorValue["saturation"];
    light: ColorValue["light"];
    alpha: ColorValue["alpha"];
}): string => {
    const alpha = color.alpha ?? 1;
    const { hue, saturation, light } = color;
    if (hue < 0 || hue > 360)
        throw new Error("Hue must be within range 0 - 360");
    if (saturation < 0 || saturation > 1)
        throw new Error("Saturation must be within range 0 - 1");
    if (light < 0 || light > 1)
        throw new Error("Light must be within range 0 - 1");
    if (alpha < 0 || alpha > 1)
        throw new Error("Alpha must be within range 0 - 1");

    const hsla = `hsla(${Math.round(hue)},${Math.round(
        saturation * 100,
    )}%,${Math.round(light * 100)}%,${alpha})`;
    // console.log("👀", hue, saturation, light, alpha, hsla);
    return hsla;
};

export { toHslaString };
